<template>
    <button
        class="l-ss-c-show-more-btn"
        :class="{ 'l-ss-c-show-more-btn-active': isActive }"
        @click="toggleShowMoreBtn">
        <span>{{ showMoreBtnText }}</span>
        <i v-html="iconArrowRight"></i>
    </button>
</template>

<script>
    import { computed } from '@vue/composition-api';

    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';

    export default {
        props: {
            value: {
                type: Boolean,
            },
        },
        setup(props, { emit, parent }) {
            const isActive = computed({
                get() {
                    return props.value;
                },
                set(value) {
                    emit('input', value);
                    emit('change', value);
                },
            });

            const showMoreBtnText = computed(() => {
                return isActive.value ? parent.$t('categories.hide') : parent.$t('categories.showAll');
            });

            const toggleShowMoreBtn = () => {
                isActive.value = !isActive.value;
                emit('click');
            };

            return {
                iconArrowRight,
                isActive,
                showMoreBtnText,
                toggleShowMoreBtn,
            };
        },
    };

</script>

<style scoped>

</style>
